/*eslint-disable*/
const useEnv = JSON.parse(process.env.VUE_APP_USE_ENV);
const api = useEnv ? '${VUE_APP_APIPATH}' : (process.env.VUE_APP_APIPATH || '');
const publicPath = useEnv ? '${VUE_APP_PUBLIC_PATH}' : process.env.VUE_APP_PUBLIC_PATH;
const baseURL = useEnv ? '${VUE_APP_PUBLIC_PATH}${VUE_APP_SUB_PATH}' : `${(process.env.VUE_APP_PUBLIC_PATH || '')}${(process.env.VUE_APP_SUB_PATH || '')}`;
const languageApi = useEnv ? '${VUE_APP_LANGUAGE}' : process.env.VUE_APP_LANGUAGE;
const teClient = useEnv ? '${VUE_APP_TECLIENT}' : process.env.VUE_APP_TECLIENT;
const SsoVueUrl = useEnv ? '${VUE_APP_SSO_VUE_URL}' : process.env.VUE_APP_SSO_VUE_URL;
export {
  api,
  publicPath,
  baseURL,
  languageApi,
  teClient,
  SsoVueUrl
};
